import AuthForm, { AuthFormProps } from 'common/components/AuthForm';
import Modal from 'common/components/Modal';
import Portal from 'common/components/Portal';
import React from 'react';

interface Props extends AuthFormProps {
    isVisible?: boolean;
    isDismissable?: boolean;
    onDismiss?: () => void;
}

const AuthModal: React.SFC<Props> = props => {
    const { isVisible, isDismissable = true, onDismiss, ...childProps } = props;

    return (
        <Portal>
            <Modal onDismiss={isDismissable ? onDismiss : undefined} isVisible={isVisible}>
                <AuthForm {...childProps} />
            </Modal>
        </Portal>
    );
};

export default AuthModal;



// WEBPACK FOOTER //
// ./js/common/components/AuthModal.tsx